export const INDENT_PADDING_TITLE = 4;
export const INDENT_PADDING_ICON = 4;
export const INDENT_PADDING_ATTR = 12;
